(() => {
  const start = () => document.querySelectorAll('[data-js6-deal-countdown]').forEach(clock => {
    if (clock.dataset.clockReady) return;
    clock.dataset.clockReady = 'true';
    const end = Date.parse(clock.dataset.js6DealCountdown);
    if (!Number.isFinite(end)) return;
    let timer;
    const update = () => {
      const left = end - Date.now();
      if (left <= 0 || !clock.isConnected) {
        clock.hidden = true;
        clearInterval(timer);
        return;
      }
      const values = [Math.floor(left / 86400000), Math.floor(left / 3600000) % 24, Math.floor(left / 60000) % 60, Math.floor(left / 1000) % 60];
      clock.querySelector('[data-js6-deal-clock]').textContent = values.map((value, i) => String(value).padStart(2, '0') + ['d', 'h', 'm', 's'][i]).join(' : ');
      clock.hidden = false;
    };
    update();
    if (!clock.hidden) timer = setInterval(update, 1000);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();

